import { useState } from 'react';
import { APP_BRAND_IDENTITY, APP_BRAND_SLOTS } from '../../_CORE/_Config/_Brand/AppBrandSlots';

const SLOT_KEYS = {
    HEADER_PUBLIC: 'headerPublic',
    HEADER_PRIVATE: 'headerPrivate',
    FOOTER_PUBLIC: 'footerPublic',
    FOOTER_PRIVATE: 'footerPrivate',
};

/*
    ========================================================================
    LOGO VISIBLE DEL PORTFOLIO - UNA SOLA FUENTE DE CONFIGURACION
    ========================================================================

    Ruta de la imagen:
        public/_Imgs/_Brand/LS_BRAND_dark.png

    Tamano y comportamiento:
        src/_CORE/_Config/Plugins/AppSwitchAppearance.js

    Este componente NO importa AppShell.Layout.js.
    Eso es intencional: AppShell importa AppModules y AppModules termina
    importando estas vistas. Importar AppShell aca crearia una dependencia
    circular y rompería la inicializacion de APP_MODULES_GET_PUBLIC_ROUTES.

    APP_BRAND_SLOTS es un modulo puro que comparte exactamente la misma
    configuracion BRAND con el Core, pero sin tocar routing.

    Ejemplos:
        slot="HEADER_PUBLIC"  -> navbar publico + login / 2FA
        slot="FOOTER_PUBLIC"  -> footer publico

    Para agrandar el logo se cambia SOLO AppSwitchAppearance.js.
*/
export const BrandLogo = ({
    slot = 'HEADER_PUBLIC',
    className = '',
    alt,
    fallback = APP_BRAND_IDENTITY.name || 'Bailador',
}) => {
    const [isBroken, setIsBroken] = useState(false);

    const slotKey = SLOT_KEYS[slot] || SLOT_KEYS.HEADER_PUBLIC;
    const brandConfig = APP_BRAND_SLOTS[slotKey] || {};
    const logoSrc = brandConfig.logoDark || brandConfig.logoLight;

    if (brandConfig.isLogo !== true || !logoSrc || isBroken) {
        return (
            <span className={`${className} ${className ? `${className}--fallback` : ''}`.trim()}>
                {fallback}
            </span>
        );
    }

    return (
        <img
            className={className}
            src={logoSrc}
            alt={alt ?? brandConfig.alt ?? 'Logo Bailador'}
            title={brandConfig.title ?? ''}
            draggable="false"
            style={brandConfig.imageStyle}
            onError={() => setIsBroken(true)}
        />
    );
};
